import React, { isValidElement, cloneElement } from 'react';

const Slot = (props) => {
  const { name, children } = props;
  return React.Children.map(children, (child) => {
    if (isValidElement(child)) {
      const isExact = child.props.slot === name;
      return isExact
        ? cloneElement(child, {
            //* remove slot from child props
            slot: undefined,
          })
        : null;
    }
  });
};
export default Slot;
